// extracted by mini-css-extract-plugin
export default {"floatingWrapper":"floatingWrapper__3rwJ1","button":"button__1AwfA","icon":"icon__48fJP"};